module.exports = __webpack_public_path__ + "24e004ab/img/dollar-icon.35c9d638.svg";